import { render, staticRenderFns } from "./tinkDevice.vue?vue&type=template&id=5e1ebb26"
import script from "./tinkDevice.vue?vue&type=script&lang=js"
export * from "./tinkDevice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports